import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
  label: {
    // @ts-expect-error - TS2339 - Property 'spacing' does not exist on type 'DefaultTheme'.
    marginLeft: theme.spacing(2)
  }
}));
